module.exports = __webpack_public_path__ + "img/app_icon.ee6ad61b.jpg";